module.exports = __webpack_public_path__ + "img/horse_item_bg_sm.1dd5cf95.jpg";